module.exports = __webpack_public_path__ + "qr1.59fca4fc.png";